import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { updateClue, useSendClueDataMutation } from 'store/clue';

// Clueを管理するためのカスタムフック
export function useClue(area: number) {
  const dispatch = useDispatch();
  const clueState = useSelector((state: RootState) => state.clue);

  const { clue, isInitialize, areaStatus, result, clueNo } = clueState;
  const [lastResult, setLastResult] = useState<boolean | null>(null);

  const [sendClueData, { isLoading: isSubmittingClue, error: submitClueError }] =
    useSendClueDataMutation();

  const updateClueState = (newClue: string) => {
    dispatch(updateClue(newClue));
  };

  const sendClue = async (clue: string) => {
    try {
      const result = await sendClueData({ password: clue, area }).unwrap();
      setLastResult(result.result);
    } catch (error) {
      console.error('Failed to send clue: ', error);
    }
  };

  return {
    clue,
    isInitialize,
    areaStatus,
    isSubmittingClue,
    submitClueError,
    updateClueState,
    sendClue,
    result,
    clueNo,
    lastResult,
  };
}
